import React, { useEffect, useState } from 'react';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import LockResetIcon from '@mui/icons-material/LockReset';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import NotificationsIcon from '@mui/icons-material/Notifications';
import SchoolIcon from '@mui/icons-material/School';
import { Box, Typography } from '@mui/material';
import CollegeOrganization from '../../pages/CollegeOrganization';
import MyProfile from './MyProfile';
import Notifications from './Notifications';
import ChangePassword from './ChangePassword';
import ApplicationInfo from './ApplicationInfo';
import ReusableTabs from '../UIElements/ReusableTabs';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AcademicYears from '../migration/AcademicYears';
import AccountCreation from './AccountCreation';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
function SettingsPage() {
  const { userDetails } = useSelector((state) => state.auth?.successData ?? {});
  const SettingsTabs = [
    userDetails &&
      userDetails?.role?.toLowerCase() === 'admin' && {
        label: 'Academics',
        icon: <SchoolIcon className='size-8 ' />,
        content: <CollegeOrganization />,
      },
    userDetails &&
      userDetails?.role?.toLowerCase() === 'admin' && {
        label: 'Acedemic Years',
        icon: <CalendarMonthIcon className='size-8 ' />,
        content: <AcademicYears />,
      },
    userDetails &&
      userDetails?.role?.toLowerCase() === 'admin' && {
        label: 'New Login',
        icon: <AccountCircleIcon className='size-8 ' />,
        content: <AccountCreation />,
      },
    {
      label: 'Notifications',
      icon: <NotificationsIcon className='size-8' />,
      content: <Notifications />,
    },
    {
      label: 'Change Password',
      icon: <LockResetIcon className='size-8' />,
      content: <ChangePassword />,
    },
    {
      label: 'My Profile',
      icon: <PersonOutlineIcon className='size-8' />,
      content: <MyProfile />,
    },
    {
      label: 'Application Info',
      icon: <InfoOutlineIcon className='size-8' />,
      content: <ApplicationInfo />,
    },
  ].filter(Boolean);
  const location = useLocation();
  const [ActiveTab, setActiveTab] = useState(0);
  useEffect(() => {
    if (location?.state?.defaultValue !== undefined)
      setActiveTab(location?.state?.defaultValue);
    // Clear the state from history
    window.history.replaceState({}, '', location.pathname);
  }, []);
  return (
    <>
      <div className='p-4 '>
        <Box className='bg-blue-50 p-4 rounded-lg'>
          <Typography variant='h6' className='text-blue-700 font-bold'>
            Settings & Academic Structure
          </Typography>
          <Typography variant='body1' className='text-gray-600'>
            Manage Academic Structure, Notifications and Application Info
          </Typography>
        </Box>
        <ReusableTabs
          tabs={SettingsTabs}
          variant='scrollable'
          allowScrollButtons={true}
          className='w-full'
          defaultTab={ActiveTab}
        />
      </div>
    </>
  );
}

export default SettingsPage;
